import {React} from 'react';

const Play = () => {
    return (
        <img src={require('../assets/playBtnPng.png')} width={'60px'} />
    )
}

export default Play
